import script from "./DecorationSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./DecorationSummary.vue?vue&type=script&setup=true&lang=ts"

import "./DecorationSummary.vue?vue&type=style&index=0&id=9ed0963c&lang=css"

const __exports__ = script;

export default __exports__